export enum CompanyTypeType {
  PIPELINE = "Pipeline",
  NON_PIPELINE = "Non Pipeline",
}

export enum CompanyTypeSubtype {
  PLATFORM = "Platform",
  PORTFOLIO = "Portfolio",
  ADD_ON = "Add-On",
  OTHER = "Other",
  BANK = "Bank",
}

export enum CompanyStageStatus {
  PROSPECT = "Prospect",
}

export enum CompanyDetailFieldType {
  TEXT = 'Text',
  PERCENTAGE = 'Percentage',
  NUMBER = 'Number',
  NUMBER_NOT_NEGATIVE = 'Number (not negative)',
  URL = 'URL',
  CURRENCY = 'Currency',
  YEAR = 'Year',
  DROPDOWN = 'Dropdown',
  LOCATION = 'Location',
}
